var map = {
	"./black_+.png": "82ae",
	"./black_..png": "5141",
	"./black_0.png": "95ff",
	"./black_1.png": "a2b1",
	"./black_2.png": "8881",
	"./black_3.png": "d26d",
	"./black_4.png": "96a5",
	"./black_5.png": "ce7f",
	"./black_6.png": "0d01",
	"./black_7.png": "9ea8",
	"./black_8.png": "3d0e8",
	"./black_9.png": "87e1",
	"./black_minute.png": "6490"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5a48";